module.exports = __webpack_public_path__ + "img/blog-post3-1.37e98345.jpg";